import { addDays, endOfDay, endOfToday, min, startOfDay, subDays } from "date-fns";

/**
 * Get options to filter the range of the phrase count chart.
 * @param dateTime Anomaly occurrence time.
 */
export const getRangeOptions = (dateTime: Date, days: number) => ({
    startDateTime: startOfDay(subDays(dateTime, days)),
    endDateTime: min([endOfDay(addDays(dateTime, days)), endOfToday()]),
});
